import {createBrowserHistory} from 'history';
import {routerMiddleware} from 'connected-react-router';
import reducers from '../reducers';
import createSagaMiddleware from 'redux-saga';
import watcherSaga from '../saga';
import {configureStore} from '@reduxjs/toolkit';
const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();


const store = configureStore({
  reducer: reducers(history),
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(routeMiddleware, sagaMiddleware),
});

sagaMiddleware.run(watcherSaga);
export default store;
export {history};
